export const LOADING_TT_ADVERTISERS = 'tt_advertisers/LOAD_TT_ADVERTISERS'
export const LOADING_TT_ADVERTISERS_SUCCESS = 'tt_advertisers/LOAD_TT_ADVERTISERS_SUCCESS'
export const LOADING_TT_ADVERTISERS_FAILURE = 'tt_advertisers/LOAD_TT_ADVERTISERS_FAILURE'
